import { formatNumberByType as format } from '../helpers'

export const formatMetrics: FormatMetrics = ({ data }) => {
  return {
    raw: data,
    conversionRate: format({ type: 'percent', value: data?.conversion_rate }),
    ecpm: format({ type: 'money', value: data?.ecpm }),
    impressions: format({ type: 'unit', value: data?.impressions }),
    impressionShare: format({
      type: 'percent',
      value: data?.impression_share ?? '-'
    }),
    lostIsRank: format({
      type: 'percent',
      value: data?.lost_is_rank ?? '-'
    }),
    lostIsBudget: format({
      type: 'percent',
      value: data?.lost_is_budget ?? '-'
    }),
    views: format({ type: 'unit', value: data?.views }),
    clicks: format({ type: 'unit', value: data?.clicks }),
    // '?? -' evita que null vire 0 na formatação (célula sem dado exibe traço)
    newToBrandCustomers: format({
      type: 'unit',
      value: data?.new_to_brand_customers ?? '-'
    }),
    newToBrandRevenue: format({
      type: 'money',
      value: data?.new_to_brand_revenue ?? '-'
    }),
    newToBrandCustomersPercent: format({
      type: 'percent',
      value: data?.new_to_brand_customers_percent ?? '-'
    }),
    newToBrandRevenuePercent: format({
      type: 'percent',
      value: data?.new_to_brand_revenue_percent ?? '-'
    }),
    requests: format({ type: 'unit', value: data?.requests }),
    conversions: format({
      type: 'unit',
      value: data?.conversions
    }),
    totalConversionsItemsQuantity: format({
      type: 'unit',
      value: data?.total_conversions_items_quantity
    }),
    income: format({
      type: 'money',
      value: data?.income
    }),
    totalSpent: format({
      type: 'money',
      value: data?.total_spent
    }),
    avgCpc: format({
      type: 'money',
      value: data?.avg_cpc
    }),
    avgCpm: format({
      type: 'money',
      value: data?.avg_cpm
    }),
    cpc: format({ type: 'money', value: data?.cpc }),
    cpa: format({ type: 'money', value: data?.cpa }),
    conversion_rate: format({
      type: 'percent',
      value: data?.conversion_rate
    }),
    ctr: format({ type: 'percent', value: data?.ctr }),
    // '?? -': a null ROAS (undefined, e.g. zero cost with return) must not become 0
    roas: format({ type: 'unit', value: data?.roas ?? '-' }),
    adcost: format({ type: 'percent', value: data?.adcost }),
    totalCampaigns: format({ type: 'unit', value: data?.total_campaigns }),
    totalDailyBudget: format({
      type: 'money',
      value: data?.total_daily_budget
    }),
    balance: format({ type: 'money', value: data?.balance }),
    consumedDailyBudget: format({
      type: 'money',
      value: data?.consumed_daily_budget
    }),
    roasClick: format({ type: 'unit', value: data?.roas_click ?? '-' }),
    conversionRateClick: format({
      type: 'percent',
      value: data?.conversion_rate_click ?? '-'
    }),
    conversionsClick: format({
      type: 'unit',
      value: data?.conversions_click ?? '-'
    }),
    incomeClick: format({
      type: 'money',
      value: data?.income_click ?? '-'
    }),
    totalConversionsItemsQuantityClick: format({
      type: 'unit',
      value: data?.total_conversions_items_quantity_click ?? '-'
    }),
    haloRevenue: format({
      type: 'money',
      value:
        data?.halo_revenue ?? data?.assisted_income ?? data?.guided_sales ?? '-'
    }),
    roasHalo: format({
      type: 'unit',
      value: data?.roas_halo ?? data?.assisted_roas ?? data?.roas_guided ?? '-'
    }),
    haloOrders: format({
      type: 'unit',
      value:
        data?.halo_orders ?? data?.assisted_orders ?? data?.guided_orders ?? '-'
    }),
    haloItems: format({
      type: 'unit',
      value: data?.assisted_items ?? '-'
    }),
    roasOverall: format({
      type: 'unit',
      value: data?.roas_overall ?? data?.overall_roas ?? '-'
    }),
    roasView: format({ type: 'unit', value: data?.roas_view ?? '-' })
  }
}
